var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoControls = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6 36a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2zM6 6v28h28V6zm12.132 5.433c-.82-.496-1.882.075-1.882 1.01v7.614c0 .936 1.063 1.506 1.882 1.01l6.29-3.807c.77-.466.77-1.554 0-2.02zM25.25 26.5h3.5a1 1 0 1 1 0 2h-3.5zm-14 0a1 1 0 1 0 0 2H21v-2z",
  clipRule: "evenodd"
})));
export default SvgVideoControls;